$(function () {
  // ==========================================================================
  // 1. GLOBALS & INIT
  // ==========================================================================

  // On a hard refresh the browser restores the previous scroll position
  // (history.scrollRestoration defaults to "auto"), often BEFORE Lenis and
  // ScrollTrigger have initialized/measured the page. ScrollTrigger's first
  // refresh() then computes pin-spacer heights and trigger start/end
  // positions assuming a fresh top-of-page layout, and the browser jumps
  // the scroll position mid-page afterwards without re-triggering a proper
  // recalculation — leaving the milestone pin stale from the first frame.
  // Taking manual control and forcing scroll-to-top before init avoids this
  // entirely.
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  window.scrollTo(0, 0);

  let winWT = $(window).innerWidth();
  let header = $("header");
  let previousScroll = 0;
  let headerHT = header.innerHeight();

  // Store ScrollTrigger instances
  let glanceST = null;
  let awardsST = null;
  let horizontalTween = null;
  let ceoTrigger = null;
  let parallaxInitialized = false;

  gsap.registerPlugin(ScrollTrigger);

  // ==========================================================================
  // 2. SMOOTH SCROLLING (LENIS)
  // ==========================================================================
  var lenis;
  var lenisTicker;

  function reconnectLenis() {
    if (typeof Lenis === "undefined") {
      console.warn("Lenis library is not loaded");
      return;
    }

    if (lenis) {
      if (lenisTicker) {
        gsap.ticker.remove(lenisTicker);
        lenisTicker = null;
      }
      lenis.destroy();
      lenis = null;
    }

    try {
      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(1.5, -10 * t)),
        orientation: "vertical",
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        infinite: false,
      });
      window.lenis = lenis;

      lenis.on("scroll", ScrollTrigger.update);

      ScrollTrigger.addEventListener("refresh", () => {
        if (lenis) lenis.resize();
      });

      lenisTicker = function (time) {
        if (lenis) lenis.raf(time * 1000);
      };

      gsap.ticker.add(lenisTicker);
      gsap.ticker.lagSmoothing(0);

      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 50);
    } catch (error) {
      console.error("Error initializing Lenis:", error);
    }
  }

  reconnectLenis();

  setTimeout(function () {
    if (lenis) lenis.resize();
    ScrollTrigger.refresh();
    requestAnimationFrame(function () {
      ScrollTrigger.update();
    });
  }, 500);

  // ==========================================================================
  // 3. CORE UI (HEADER, FOOTER, CURSOR, MENUS)
  // ==========================================================================
  let menuTl = gsap.timeline();

  /* $("#header").load("header.html", function () {
    previousScroll = 0;
    headerHT = header.innerHeight();
    menuTl = gsap.timeline();

    addHoverCursorClass();
    headerSetup();
    hideMenuSrollbar();
    homeLeaderboard();
    searchPage();
    modeToggler();
  }); */

  /* $("#footer").load("footer.html", function () {
    // footer loaded 
  }); */

  function waitForHeader(cb) {
    if ($("header nav").length && $("header .nav-hld").length) {
      cb();
    } else {
      setTimeout(() => waitForHeader(cb), 50);
    }
  }

  $(document).on("click", ".nav-icon", function () {
    if (!$("header nav").length || !$("header .nav-hld").length) return;

    if ($(this).hasClass("open")) {
      resetMobileMenu();
    } else {
      $(this).addClass("open");
      $("header nav").animate({ right: 0 }, 300);
      gsap.to(".hd-overlay", { duration: 0.2, opacity: 1 });
      $(".hd-overlay").css({ "pointer-events": "auto" });
    }
  });

  $(document).on("click", "header .hd-overlay", function () {
    resetMobileMenu();
  });

  function resetMobileMenu() {
    let navWT = $("header nav").innerWidth();
    if (!$("header nav").length || !$("header .nav-hld").length) return;
    $(".nav-icon").removeClass("open");
    $("header nav").animate({ right: -navWT + "px" }, 300);
    gsap.to(".hd-overlay", { duration: 0.2, opacity: 0 });
    $(".hd-overlay").css({ "pointer-events": "none" });
  }

  function setHeaderOnScroll() {
    winWT = $(window).innerWidth();
    if (winWT > 1100) {
      if ($(window).scrollTop() > 120) {
        $("header").addClass("sticky");
      } else {
        $("header").removeClass("sticky");
      }
    }
  }

  function setHeaderAnim() {
    winWT = $(window).innerWidth();
    if (winWT >= 1024) {
      const currentScroll = $(window).scrollTop();
      if (currentScroll > previousScroll) {
        header.css("top", -(headerHT + 18) + "px");
      } else {
        header.css("top", "0");
      }
      previousScroll = currentScroll;
    }
  }

  function hideMenuSrollbar() {
    $(".dropdown-toggle").on("click", function () {
      const $this = $(this);
      setTimeout(function () {
        if ($this.hasClass("show")) {
          $("header .navbar-expand-lg").css({ overflowY: "scroll" });
        } else {
          $("header .navbar-expand-lg").css({ overflowY: "hidden" });
        }
      }, 500);
    });
  }

  function headerSetup() {
    $(document).click(function (event) {
      var clickover = $(event.target);
      var _opened = $(".navbar-collapse").hasClass("show");
      if (_opened === true && !clickover.hasClass("navbar-toggler")) {
        $(".navbar-toggler").click();
      }
    });

    $(".dropdown-toggle").each(function () {
      var $toggle = $(this);
      if ($toggle.attr("data-bs-toggle") === "dropdown") {
        $toggle.attr("data-original-bs-toggle", "dropdown");
        $toggle.removeAttr("data-bs-toggle");
      }
    });

    $(".dropdown-toggle").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $toggle = $(this);
      var $currentMenu = $toggle.next(".dropdown-menu");

      $(".dropdown-toggle")
        .not($toggle)
        .each(function () {
          var $otherToggle = $(this);
          var $otherMenu = $otherToggle.next(".dropdown-menu");
          if ($otherMenu.is(":visible")) {
            $otherMenu.stop(true, true).slideUp(200);
            $otherToggle.removeClass("show");
            $otherMenu.removeClass("show");
          }
        });

      if ($currentMenu.is(":visible")) {
        $currentMenu.stop(true, true).slideUp(200);
        $toggle.removeClass("show");
        $currentMenu.removeClass("show");
      } else {
        $currentMenu.stop(true, true).slideDown(200, function () {
          $toggle.addClass("show");
          $currentMenu.addClass("show");
        });
      }
    });
  }

  const cursor = document.getElementById("cursor");
  const ring = document.getElementById("cursorRing");
  let mouseX = 0,
    mouseY = 0,
    ringX = 0,
    ringY = 0;

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (cursor) gsap.set(cursor, { x: mouseX, y: mouseY });
  });

  gsap.ticker.add(() => {
    ringX += (mouseX - ringX) * 0.12;
    ringY += (mouseY - ringY) * 0.12;
    if (ring) gsap.set(ring, { x: ringX, y: ringY });
  });

  function addHoverCursorClass() {
    $("a").each(function () {
      $(this).on("mouseenter", () => {
        if (cursor) $(cursor).addClass("hover");
        if (ring) $(ring).addClass("hover");
      });
      $(this).on("mouseleave", () => {
        if (cursor) $(cursor).removeClass("hover");
        if (ring) $(ring).removeClass("hover");
      });
    });

    $(".swiper-button-next, .swiper-button-prev").each(function () {
      $(this).on("mouseenter", () => {
        if (cursor) $(cursor).addClass("hover");
      });
      $(this).on("mouseleave", () => {
        if (cursor) $(cursor).removeClass("hover");
      });
    });
  }

  $(".slide-controller-con").on({
    mouseenter: function () {
      $(".cursor-ring").css({ opacity: 0 });
    },
    mouseleave: function () {
      $(".cursor-ring").css({ opacity: 1 });
    },
  });

  // ==========================================================================
  // 4. SLIDERS & CAROUSELS (SWIPER, TABS)
  // ==========================================================================
  let productSwiperSlider = null;

  function setTabSlider() {
    $(".nav-tabs-con").each(function () {
      var $container = $(this);
      var $navTabs = $container.find("li button");
      var $slider = $container.find(".slider");
      var $activeTab = $container.find(".active").parent("li");

      if ($activeTab.length) {
        $slider.css({
          left: $activeTab.position().left,
          width: $activeTab.width(),
        });
      }

      $navTabs.off("click.tabSlider").on("click.tabSlider", function () {
        var $parent = $(this).parent();
        var position = $parent.position();
        var currTab = $(this).attr("data-bs-target");

        $slider.css({
          left: position.left,
          width: $parent.width(),
        });

        $(currTab).find(".cat-hld").css({ left: position.left });
      });
    });
  }

  function initProductsSlider() {
    if (!window.productsData) {
      if (!window.__productsDataRetries) window.__productsDataRetries = 0;
      if (window.__productsDataRetries++ < 40) setTimeout(initProductsSlider, 50);
      return;
    }

    const wrapper = document.getElementById("swiper-wrapper");
    if (!wrapper) return;

    const { icons, products } = window.productsData;

    if (productSwiperSlider && !productSwiperSlider.destroyed) {
      productSwiperSlider.destroy(true, true);
      productSwiperSlider = null;
    }

    wrapper.innerHTML = "";

    products.forEach((p) => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.innerHTML = `
        <div class="icon-stack">
          <div class="icon-label">${p.label}</div>
          <div class="icon-circle">${icons[p.icon]}</div>
        </div>
      `;
      wrapper.appendChild(slide);
    });

    function getCurveHeight(width) {
      return width * 0.25;
    }

    function getRadius(width, height) {
      return (Math.pow(width / 2, 2) + Math.pow(height, 2)) / (2 * height);
    }

    function getCircleY(x, radius) {
      const clampedX = Math.min(Math.abs(x), radius);
      return radius - Math.sqrt(Math.pow(radius, 2) - Math.pow(clampedX, 2));
    }

    function drawStaticCurve() {
      const svgPath = document.getElementById("connector-path");
      const trackWrapper = document.querySelector(".slider-wrapper");
      const activeCircle = document.querySelector(".swiper-slide-active .icon-circle");

      if (
        !svgPath ||
        !trackWrapper ||
        !activeCircle ||
        !productSwiperSlider ||
        productSwiperSlider.slides.length < 2
      ) {
        return;
      }

      const wrapRect = trackWrapper.getBoundingClientRect();
      const circleRect = activeCircle.getBoundingClientRect();
      const yOrigin = circleRect.top - wrapRect.top + circleRect.height / 2;
      const swiperW = trackWrapper.offsetWidth;
      const center = swiperW / 2;
      const h = getCurveHeight(swiperW);
      const r = getRadius(swiperW, h);

      let d = "";
      for (let x = 0; x <= swiperW; x += 5) {
        const dist = x - center;
        const y = yOrigin + getCircleY(dist, r);
        d += (x === 0 ? "M " : "L ") + x + " " + y;
      }
      svgPath.setAttribute("d", d);
    }

    productSwiperSlider = new Swiper(".products-swiper", {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 7,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".products-next",
        prevEl: ".products-prev",
      },
      breakpoints: {
        560: { slidesPerView: 4.5, spaceBetween: 15 },
        900: { slidesPerView: 5.5, spaceBetween: 20 },
        1100: { slidesPerView: 6.5, spaceBetween: 30 },
      },
      on: {
        init: function () {
          this.slideToLoop(3, 0, false);
          setTimeout(drawStaticCurve, 50);
        },
        slideChangeTransitionEnd: function () {
          drawStaticCurve();
        },
      },
    });

    function trackPositionsOnCurve() {
      if (productSwiperSlider && !productSwiperSlider.destroyed) {
        const swiperW = productSwiperSlider.width;
        if (swiperW > 0) {
          const h = getCurveHeight(swiperW);
          const r = getRadius(swiperW, h);
          const swiperCenter = swiperW / 2;
          const currentTranslateX = productSwiperSlider.getTranslate();

          productSwiperSlider.slides.forEach((slide) => {
            const slideCenterBase = slide.offsetLeft + slide.offsetWidth / 2;
            const slideCenterPos = slideCenterBase + currentTranslateX;
            const distFromCenter = slideCenterPos - swiperCenter;
            const yDrop = getCircleY(distFromCenter, r);
            const stack = slide.querySelector(".icon-stack");
            if (stack) stack.style.transform = `translateY(${yDrop}px)`;
          });
        }
        requestAnimationFrame(trackPositionsOnCurve);
      }
    }

    requestAnimationFrame(trackPositionsOnCurve);

    if (window.__productsResizeHandler) {
      window.removeEventListener("resize", window.__productsResizeHandler);
    }

    window.__productsResizeHandler = function () {
      if (productSwiperSlider && !productSwiperSlider.destroyed) {
        productSwiperSlider.translateTo(productSwiperSlider.translate, 0);
        drawStaticCurve();
      }
    };

    window.addEventListener("resize", window.__productsResizeHandler);
  }

  function highlightSliders() {
    if ($(".highlights-hld").length > 0) {
      let highlitSlider1, highlitSlider2;

      if (highlitSlider1 && !highlitSlider1.destroyed) highlitSlider1.destroy(true, true);
      if (highlitSlider2 && !highlitSlider2.destroyed) highlitSlider2.destroy(true, true);

      highlitSlider1 = new Swiper(".highlit1-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".highlit1-slider .swiper-button-next",
          prevEl: ".highlit1-slider .swiper-button-prev",
        }, 
        breakpoints: {
          320: { slidesPerView: 1.2, spaceBetween: 20 },
          575: { slidesPerView: 1.5, spaceBetween: 20 },
          640: { slidesPerView: 2.5, spaceBetween: 20 },
          768: { slidesPerView: 3.2, spaceBetween: 20 },
          1024: { slidesPerView: 5, spaceBetween: 20 },
          1366: { slidesPerView: 5, spaceBetween: 20 },
          1600: { slidesPerView: 6, spaceBetween: 20 },
        },
      });

      highlitSlider2 = new Swiper(".highlit2-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".highlit2-slider .swiper-button-next",
          prevEl: ".highlit2-slider .swiper-button-prev",
        }, 
        breakpoints: {
          320: { slidesPerView: 1.2, spaceBetween: 20 },
          575: { slidesPerView: 1.5, spaceBetween: 20 },
          640: { slidesPerView: 2.5, spaceBetween: 20 },
          768: { slidesPerView: 3.2, spaceBetween: 20 },
          1024: { slidesPerView: 5, spaceBetween: 20 },
          1366: { slidesPerView: 5, spaceBetween: 20 },
          1400: { slidesPerView: 7, spaceBetween: 20 },
        },
      });
    }
  }

  function setESGSlider() {
    if ($(".priorities-slider").length > 0) {
      let prioritiesSwiper = null;
      const mobileQuery = window.matchMedia("(max-width: 1023px)");

      function initPrioritiesSlider() {
        if (mobileQuery.matches && !prioritiesSwiper) {
          prioritiesSwiper = new Swiper(".priorities-slider", {
            spaceBetween: 20,
            slidesPerView: 1.1,
            speed: 600,
            autoHeight: true,
            navigation: {
              nextEl: ".priorities-slider .swiper-button-next",
              prevEl: ".priorities-slider .swiper-button-prev",
            },
            breakpoints: {
              575: { slidesPerView: 1.5 },
              768: { slidesPerView: 2.1 },
            },
          });
        } else if (!mobileQuery.matches && prioritiesSwiper) {
          prioritiesSwiper.destroy(true, true);
          prioritiesSwiper = null;
        }
      }

      initPrioritiesSlider();
      mobileQuery.addEventListener("change", initPrioritiesSlider);
    }
  }

  function whatWeBuildSLider() {
    if ($(".we-build-for-slider").length > 0) {
      new Swiper(".we-build-for-slider", {
        spaceBetween: 20,
        slidesPerView: 3,
        speed: 600,
        autoHeight: true,
        navigation: {
          nextEl: ".we-build-for-slider .swiper-button-next",
          prevEl: ".we-build-for-slider .swiper-button-prev",
        },
        breakpoints: {
          320: { slidesPerView: 1.2 },
          575: { slidesPerView: 1.5 },
          768: { slidesPerView: 2.1 },
          1023: { slidesPerView: 3 },
        },
      });
    }
  }

  function aiWorkforceSwiper() {
    if ($(".aiWorkforceSwiper").length > 0) {
      new Swiper(".aiWorkforceSwiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed:5000,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".custom-pagination",
          clickable: "true",
        },
      });
    }
  }

  function mobTimelineSlider() {
    if ($(".time-line-box").length > 0) {
      const headings = [
        "The Bajaj Group: 100 years in the making",
        "Delivering today. Built for what's next",
      ];

      const heading = document.getElementById("timelineHeading");

      const swiper = new Swiper(".swiper-container", {
        slidesPerView: 5,
        spaceBetween: 0,
        navigation: {
          nextEl: ".timeline-nav--next",
          prevEl: ".timeline-nav--prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 0,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 0,
            slidesPerGroup: 4,
          },
        },
        on: {
          init: function () {
            if (heading) heading.textContent = headings[0];
          },
          slideChange: function () {
            if (!heading) return;
            if (this.activeIndex < 4) {
              heading.textContent = headings[0];
            } else {
              heading.textContent = headings[1];
            }
          },
        },
      });
    }
  }

  function initSliders() {
    setESGSlider();
    initProductsSlider();
    whatWeBuildSLider();
    aiWorkforceSwiper();
    highlightSliders();
    mobTimelineSlider();
  }

  // ==========================================================================
  // 5. SCROLL ANIMATIONS (GSAP, PARALLAX, SVG, TEXT)
  // ==========================================================================

  function parallaxBanner() {
    if (parallaxInitialized) {
      ScrollTrigger.getAll().forEach((trigger) => {
        if (
          trigger.vars.trigger &&
          trigger.vars.trigger.classList &&
          trigger.vars.trigger.classList.contains("parallax-banner")
        ) {
          trigger.kill();
        }
      });
    }

    gsap.utils.toArray(".parallax-banner").forEach(function (container) {
      let image = container.querySelector("img");
      if (!image) return;

      image.style.transform = "translateY(-30%) scale(1.2)";
      image.style.transformOrigin = "center center";

      function setupParallax() {
        image.style.transform = "";
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
          },
        });

        tl.fromTo(
          image,
          { yPercent: -30, scale: 1.2 },
          { yPercent: 30, scale: 1, ease: "none" }
        );
      }

      if (image.complete && image.naturalHeight !== 0) {
        setupParallax();
      } else {
        image.addEventListener("load", setupParallax, { once: true });
        image.addEventListener("error", setupParallax, { once: true });
      }
    });

    parallaxInitialized = true;
  }

  function animIntroText() {
    let bannerH2 = document.querySelector(".org-snapshot .sect-tl p");
    if (!bannerH2 || typeof SplitText === "undefined") return;

    let split = new SplitText(bannerH2, { type: "words" });
    let words = split.words;

    gsap.set(words, { opacity: 0 });

    ScrollTrigger.create({
      trigger: ".org-snapshot",
      start: "top 70%",
      end: "bottom 100%",
      once: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const totalWords = words.length;

        words.forEach((word, index) => {
          const wordProgress = index / totalWords;
          const nextWordProgress = (index + 1) / totalWords;
          let opacity = 0;

          if (progress >= nextWordProgress) opacity = 1;
          else if (progress >= wordProgress) {
            opacity = (progress - wordProgress) / (nextWordProgress - wordProgress);
          }

          gsap.to(word, {
            opacity: opacity,
            duration: 0.01,
            overwrite: false,
          });
        });
      },
    });
  }

  function animSectionTitle() {
    if (typeof SplitText === "undefined") return;

    document.querySelectorAll(".sect-tl").forEach((section) => {
      const title = section.querySelector("h2");
      if (!title) return;

      const split = new SplitText(title, { type: "words" });
      gsap.set(split.words, { opacity: 0, y: 50 });

      gsap.to(split.words, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          once: true,
        },
      });
    });
  }

  let wowInstance = null;

  function initWowAnimations() {
    if (typeof WOW === "undefined") return;

    if (!wowInstance) {
      wowInstance = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 150,
        mobile: true,
        live: false
      });
      wowInstance.init();
    } else {
      wowInstance.sync();
    }
  }

  initWowAnimations();

  // ==========================================================================
  // 5A. HORIZONTAL SCROLL (MILESTONES) - FIXED VERSION
  // ==========================================================================
  let milestoneRO = null;
  let bodyRO = null;
  let milestoneLastSignature = null;
  let lastBodyHeight = 0;
  let isBuildingMilestone = false;
  let bodyRefreshTimer = null;
  let tabSwitchTimer = null;
  let isTabSwitching = false;

  function buildHorizontalScroll(force = false) {
    if (isBuildingMilestone) return;

    const section = document.querySelector(".mileStonWrp");
    if (!section) return;

    // On a forced rebuild (resize etc.) release any existing pin BEFORE
    // measuring. Otherwise the section is still position:fixed with an
    // inline width baked in from before the resize, so offsetWidth /
    // track.scrollWidth read stale numbers and the new pin-spacer height
    // ends up wrong.
    if (force) {
      const staleST = ScrollTrigger.getById("milestone-horizontal");
      if (staleST) staleST.kill(true);
    }

    if (section.offsetWidth === 0 || section.offsetHeight === 0) return;

    const track = section.querySelector(".inerWrp");
    if (!track) return;

    const w = section.offsetWidth;
    const h = section.offsetHeight;
    const totalTrackWidth = track.scrollWidth;
    const sig = `${w}x${h}x${totalTrackWidth}`;

    if (!force && sig === milestoneLastSignature && ScrollTrigger.getById("milestone-horizontal")) {
      return;
    }

    isBuildingMilestone = true;

    try {
      const existingST = ScrollTrigger.getById("milestone-horizontal");
      if (existingST) existingST.kill(true);

      if (horizontalTween) {
        horizontalTween.kill();
        horizontalTween = null;
      }

      const cards = gsap.utils.toArray(section.querySelectorAll(".js-trigger"));

      gsap.set(track, { x: 0 });

      const totalMove = Math.max(0, totalTrackWidth - window.innerWidth);
      const startBuffer = window.innerHeight * 0.6;
      const endBuffer = window.innerHeight * 0.6;
      const totalScroll = startBuffer + totalMove + endBuffer;

      const moveStartFrac = totalScroll ? startBuffer / totalScroll : 0;
      const moveEndFrac = totalScroll ? (startBuffer + totalMove) / totalScroll : 1;

      function updateActiveCard(progress) {
        if (!cards.length) return;

        if (progress <= moveStartFrac) {
          cards.forEach((c) => c.classList.remove("active"));
          cards[0].classList.add("active");
          return;
        }

        if (progress >= moveEndFrac) {
          cards.forEach((c) => c.classList.remove("active"));
          cards[cards.length - 1].classList.add("active");
          return;
        }

        let closest = null;
        let closestDistance = Infinity;

        cards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const center = rect.left + rect.width / 2;
          const distance = Math.abs(window.innerWidth / 2 - center);

          if (distance < closestDistance) {
            closestDistance = distance;
            closest = card;
          }
        });

        cards.forEach((card) => card.classList.remove("active"));
        if (closest) closest.classList.add("active");
      }

      horizontalTween = gsap.timeline({
        scrollTrigger: {
          id: "milestone-horizontal",
          trigger: section,
          start: "top 10%",
          end: () => `+=${totalScroll}`,
          pin: true,
          scrub: 1,
          anticipatePin: 1,
          refreshPriority: 1,
          invalidateOnRefresh: true,
          onUpdate: (self) => updateActiveCard(self.progress),
          onRefresh: (self) => updateActiveCard(self.progress),
          onLeave: () => {
            updateActiveCard(1);
            gsap.set(track, { x: -totalMove });
          },
          onLeaveBack: () => {
            updateActiveCard(0);
            gsap.set(track, { x: 0 });
          },
        },
      });

      horizontalTween
        .to(track, { x: 0, duration: startBuffer })
        .to(track, { x: -totalMove, ease: "none", duration: totalMove })
        .to(track, { x: -totalMove, duration: endBuffer });

      milestoneLastSignature = sig;
      lastBodyHeight = document.documentElement.scrollHeight;
      updateActiveCard(0);

      if (typeof lenis !== "undefined" && lenis) {
        requestAnimationFrame(() => lenis.resize());
      }
    } finally {
      requestAnimationFrame(() => {
        isBuildingMilestone = false;
      });
    }
  }

  function refreshMilestoneForHeightChange() {
    if (isBuildingMilestone || isTabSwitching) return;

    const existingST = ScrollTrigger.getById("milestone-horizontal");

    if (!existingST) {
      buildHorizontalScroll();
      return;
    }

    // Defer by a couple of frames so the browser finishes reflowing after
    // whatever caused document.body's height to change (Lenis-tracked
    // content/DOM height changes elsewhere on the page).
    //
    // IMPORTANT: this must fully REBUILD (buildHorizontalScroll(true)),
    // not just ScrollTrigger.refresh(). The pin's `end` is a closure
    // (`() => `+=${totalScroll}`) where totalScroll was computed once at
    // build time from totalTrackWidth/window.innerWidth — a refresh only
    // re-measures trigger start positions, it never re-evaluates that
    // captured totalScroll. So a body-height change without a rebuild can
    // leave the pin-spacer height permanently stale, which is what causes
    // sections to overlap once the document height/scroll gets clamped.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (isTabSwitching) return;
        buildHorizontalScroll(true);
        ScrollTrigger.refresh(true);
        if (typeof lenis !== "undefined" && lenis) lenis.resize();
        lastBodyHeight = document.documentElement.scrollHeight;
      });
    });
  }

  function createHorizontalScroll(force = false) {
    const section = document.querySelector(".mileStonWrp");
    if (!section) return;

    buildHorizontalScroll(force);

    if (milestoneRO) milestoneRO.disconnect();

    milestoneRO = new ResizeObserver((entries) => {
      if (isBuildingMilestone || isTabSwitching) return;

      for (const entry of entries) {
        const w = Math.round(entry.contentRect.width);
        const h = Math.round(entry.contentRect.height);
        const track = section.querySelector(".inerWrp");
        const trackScrollW = track ? track.scrollWidth : 0;
        const signature = `${section.offsetWidth}x${section.offsetHeight}x${trackScrollW}`;

        if (w > 0 && h > 0 && signature !== milestoneLastSignature) {
          buildHorizontalScroll(true);
          break;
        }
      }
    });

    milestoneRO.observe(section);

    const track = section.querySelector(".inerWrp");
    if (track) milestoneRO.observe(track);

    if (bodyRO) bodyRO.disconnect();

    bodyRO = new ResizeObserver(() => {
      if (isBuildingMilestone || isTabSwitching) return;

      clearTimeout(bodyRefreshTimer);
      bodyRefreshTimer = setTimeout(() => {
        const currentHeight = document.documentElement.scrollHeight;
        if (currentHeight !== lastBodyHeight) {
          lastBodyHeight = currentHeight;
          refreshMilestoneForHeightChange();
        }
      }, 120);
    });

    bodyRO.observe(document.body);
  }

  // ==========================================================================
  // 5B. HIGHLIGHTS PANEL PIN
  // ==========================================================================
  let highlitTl = null;

function pinHighlightsPanel(forceRebuild = false) {
  const panel = $(".highlights-hld");
  if (!panel.length) return;

  winWT = $(window).innerWidth();
  const shouldPin = winWT > 1023;
  const isPanelVisible = panel.is(":visible");

  // On mobile or hidden tab, destroy
  if (!shouldPin || !isPanelVisible) {
    if (highlitTl) {
      if (highlitTl.scrollTrigger) highlitTl.scrollTrigger.kill(true);
      highlitTl.kill();
      highlitTl = null;
    }
    return;
  }

  // Force rebuild if needed
  if (forceRebuild && highlitTl) {
    if (highlitTl.scrollTrigger) highlitTl.scrollTrigger.kill(true);
    highlitTl.kill();
    highlitTl = null;
  }

  // If already exists, only refresh
  if (highlitTl && highlitTl.scrollTrigger) {
    highlitTl.scrollTrigger.refresh();
    return;
  }

  gsap.set(".higlit-1", { autoAlpha: 1 });
  gsap.set(".higlit-2", { autoAlpha: 0 });

  highlitTl = gsap.timeline({
    scrollTrigger: {
      id: "highlights-pin",
      trigger: ".highlights-hld",
      start: "top 10%",
      end: "+=100%",
      scrub: 1,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true
    }
  });

  highlitTl
    .to(".higlit-1", { autoAlpha: 0, duration: 1 }, 0.4)
    .to(".higlit-2", { autoAlpha: 1, duration: 1 }, 0.4);
}

  // ==========================================================================
  // 5C. OTHER SCROLL ITEMS
  // ==========================================================================
  function initCeoSticky() {
    if ($("#ceopan").length > 0) {
      const stickyQuery = window.matchMedia("(min-width: 992px)");

      function apply() {
        if (stickyQuery.matches && !ceoTrigger) {
          ceoTrigger = ScrollTrigger.create({
            trigger: ".ceopic-sticky",
            start: "top 150px",
            endTrigger: ".chairmen-content",
            end: "bottom bottom",
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
          });
        } else if (!stickyQuery.matches && ceoTrigger) {
          ceoTrigger.kill();
          ceoTrigger = null;
        }
      }

      apply();
      stickyQuery.addEventListener("change", apply);
    }
  }

  function callCounters() {
    const counters = document.querySelectorAll(".counter");
    counters.forEach((counter) => {
      counter.innerText = "0";
      const updateCounter = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText.replace(/,/g, "");
        const increment = target / 200;
        if (count < target) {
          const nextValue = Math.ceil(count + increment);
          counter.innerText = Number.isInteger(nextValue)
            ? nextValue.toLocaleString()
            : nextValue.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 2 });
          setTimeout(updateCounter, 9);
        } else {
          counter.innerText = Number.isInteger(target)
            ? target.toLocaleString()
            : target.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 2 });
        }
      };
      updateCounter();
    });
  }

  function homeLeaderboard(){
    $('#ldrshipWrp .ldrsjip li').click( function() {
      $(this).toggleClass('active').siblings().removeClass('active');
    });
  }

  function revealImages(){
    const images = document.querySelectorAll(".reveal-images"); 
    const removeOverlay = overlay => {
      let tl = gsap.timeline(); 
      tl.to(overlay, {
        duration: 1.4,
        ease: "Power2.easeInOut",
        width: "0%" 
      }); 
      return tl;
    }; 
    const scaleInImage = image => {
      let tl = gsap.timeline(); 
      tl.from(image, {
        duration: 1.4,
        scale: 1,
        opacity:1,
        ease: "Power2.easeInOut"
      }); 
      return tl;
    }; 
    images.forEach(image => { 
      gsap.set(image, {
        visibility: "visible"
      }); 
      const overlay = image.querySelector('.reveal-overlay');
      const img = image.querySelector("img");
      let hasAnimated = false; // Flag to track if animation has played

      const masterTL = gsap.timeline({ paused: true });
      masterTL
      .add(removeOverlay(overlay))
      .add(scaleInImage(img), "-=1.4"); 
      let options = {
        threshold: 0
      } 
      const io = new IntersectionObserver((entries, options) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasAnimated) {
            masterTL.play();
            hasAnimated = true; // Mark as animated
          }
        });
      }, options);

      io.observe(image); 
    });
  }

  $('.transformation-hld').find('.nav-item').each(function () {
    $(this).on('click', function () {
      let currTabAttr = $(this).attr('id');
      let currTxt = '.finai-' + currTabAttr;
      gsap.set('.finai-text', { opacity: 0 });
      gsap.to(currTxt, { opacity: 1 });
    });
  });

  function animateSVGLines() { 
    const sectionConfigs = [
        {
          sectionId: 'report-intro',
          svgId: 'svg1',
          nativeSize: { w: 155, h: 500 },
          pathBuilder: () => 'M0 1C0 1 121.11 1 134.055 1C147 1 154 7.73218 154 20.7321C154 31.0643 154 278.915 154 387.229',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#000",
          scrubStart: 'top 70%',
          scrubEnd: 'bottom 20%'  
        },
        {
          sectionId: 'milestones',
          svgId: 'svg2',
          nativeSize: { w: 155, h: 500 },
          pathBuilder: () => 'M1.00119 139C1.00119 139 0.998515 99 1.00119 87.5C1.00386 76 12.4923 69.0027 22.5012 69.0027C32.5101 69.0027 1719.95 69.0025 1732 69.0025C1745 69.0025 1752 62.0027 1752 48.0025C1752 45.1813 1752 27.1319 1752 0',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#000",
          scrubStart: 'top 70%',
          scrubEnd: 'bottom 20%'  
        },
        {
          sectionId: 'highlights',
          svgId: 'svg3',
          nativeSize: { w: 1920, h: 2 },
          pathBuilder: () => 'M -1 1 L 1919 1',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#000",
          scrubStart: 'top 20%',
          scrubEnd: 'bottom 70%'  
        },
        {
          sectionId: 'chairman-msg',
          svgId: 'svg4',
          nativeSize: { w: 1775, h: 616 },
          pathBuilder: () => 'M1775 1.11467H49.5C13.8605 -0.00278136 4.10801 6.78542 1 29.1162V433.615C1.83958 466.291 11.7512 473.4 40.5 473.115H765C801.15 475.871 810.593 486.783 812 520.115V615.615',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#000",
          scrubStart: 'top 70%',
          scrubEnd: 'bottom 20%'  
        },
        {
          sectionId: 'our-products',
          svgId: 'svg5',
          nativeSize: { w: 1624, h: 994 },
          pathBuilder: () => 'M1 0C1 0 1 95 1 110C1 125 16 140 31 140C46 140 768 140.268 782.5 140.268C797 140.268 812.489 154.5 812.489 170C812.489 183.665 812.118 942.299 812.03 1131',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#000000",
          scrubStart: 'top 50%',
          scrubEnd: 'bottom 50%' 
        },
        {
          sectionId: 'digital-first',
          svgId: 'svg6',
          nativeSize: { w: 1625, h: 910 },
          pathBuilder: () => 'M1623.03 0.000488281C1623.02 24.1338 1623.01 38.4471 1623.01 40.0029C1623.01 53.5029 1608 70.0029 1593 70.0029C1578 70.0029 47.4997 70.0029 31 70.0029C14.5003 70.0029 1 85.5029 1 101.003C1 114.573 1 743.276 1 910',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#000000",
          scrubStart: 'top 50%',
          scrubEnd: 'bottom 50%' 
        },
        {
          sectionId: 'finai-transformation',
          svgId: 'svg7',
          nativeSize: { w: 1624, h: 994 },
          pathBuilder: () => 'M1 0C1 0 1 916.304 1 932.402C1 948.5 16.5001 963 31.5 963C45.8769 963 1453.9 963 1584 963',
          dashArray: "3 6",
          strokeWidth: "2",
          strokeColor: "#ffffff",
          scrubStart: 'top 50%',
          scrubEnd: 'bottom 50%' 
        },
        {
            sectionId: 'finance-with-ai',
            svgId: 'svg8',
            nativeSize: { w: 41, h: 1150 },
            pathBuilder: () => 'M0.113281 1.16428C22.1133 -1.33607 39.6133 13.6643 39.6133 31.1643C39.6133 48.6643 39.6133 1108.66 39.6133 1108.66',
            dashArray: "3 6",
            strokeWidth: "2",
            strokeColor: "#ffffff", 
            scrubStart: 'top 50%',
            scrubEnd: 'bottom 80%'
        },
        {
            sectionId: 'people-culture',
            svgId: 'svg9',
            nativeSize: { w: 2, h: 944 },
            pathBuilder: () => 'M1 0V944',
            dashArray: "3 6",
            strokeWidth: "2",
            strokeColor: "#000000", 
            scrubStart: 'top 50%',
            scrubEnd: 'bottom 80%'
        },
        {
            sectionId: 'brand-identity',
            svgId: 'svg11',
            nativeSize: { w: 1624, h: 1081 },
            pathBuilder: () => 'M1623 0C1623 24.1149 1623 38.5725 1623 40.5029C1623 57.5029 1607.5 69.5122 1593 69.5122C1578.5 69.5122 47 69.9937 31 69.9937C15 69.9937 1 84.5029 1 100.003C1 113.761 2.30995 892.988 2.60438 1080.5',
            dashArray: "3 6",
            strokeWidth: "2",
            strokeColor: "#000000", 
            scrubStart: 'top 50%',
            scrubEnd: 'bottom 80%'
        },
        {
            sectionId: 'build-for',
            svgId: 'svg12',
            nativeSize: { w: 1624, h: 902 },
            pathBuilder: () => 'M1 0C1 0 1 15 1 37.5C1 60 14.5 70 32.5 70C50.5 70 1557 70 1582 70C1607 70 1623 79.5 1623 100C1623 120.5 1623 902 1623 902',
            dashArray: "3 6",
            strokeWidth: "2",
            strokeColor: "#000000", 
            scrubStart: 'top 50%',
            scrubEnd: 'bottom 80%'
        }
    ];

    function attachConnector(config) {
        const section = document.getElementById(config.sectionId);
        const container = document.getElementById(config.svgId);
        if (!section || !container) return;

        let scrollTween = null;
        
        const numCircles = Math.floor(Math.random() * 3) + 6; 
        const circlePositions = [];
        const segmentSize = 1.0 / numCircles; 
        const padding = segmentSize * 0.2; 

        for(let i = 0; i < numCircles; i++) {
            const minVal = (i * segmentSize) + padding;
            const maxVal = ((i + 1) * segmentSize) - padding;
            const randomFraction = minVal + (Math.random() * (maxVal - minVal));
            circlePositions.push(randomFraction);
        }

        function build() {
            if (scrollTween) {
                scrollTween.scrollTrigger.kill();
                scrollTween.kill();
            }
            container.innerHTML = '';

            const pathData = config.pathBuilder();
            const vBoxW = config.nativeSize.w;
            const vBoxH = config.nativeSize.h;

            const svgNS = "http://www.w3.org/2000/svg";
            const svgEl = document.createElementNS(svgNS, "svg");
            
            svgEl.setAttribute("viewBox", `0 0 ${vBoxW} ${vBoxH}`);
            svgEl.setAttribute("preserveAspectRatio", "none");
            
            // ---> FIX: Allow circles to bleed over the edge without getting clipped <---
            svgEl.style.overflow = "visible"; 
            
            const defs = document.createElementNS(svgNS, "defs");
            const mask = document.createElementNS(svgNS, "mask");
            mask.setAttribute("id", `mask-${config.sectionId}`);

            const maskPath = document.createElementNS(svgNS, "path");
            maskPath.setAttribute("d", pathData);
            maskPath.setAttribute("fill", "none");
            maskPath.setAttribute("stroke", "#ffffff");
            
            // Made the mask stroke thicker just to ensure it fully uncovers the circle radius
            maskPath.setAttribute("stroke-width", "50"); 
            maskPath.setAttribute("vector-effect", "non-scaling-stroke"); 
            
            mask.appendChild(maskPath);
            defs.appendChild(mask);
            svgEl.appendChild(defs);

            const visiblePath = document.createElementNS(svgNS, "path");
            visiblePath.setAttribute("d", pathData);
            visiblePath.setAttribute("vector-effect", "non-scaling-stroke"); 
            visiblePath.setAttribute("fill", "none");
            visiblePath.setAttribute("stroke", config.strokeColor || "#000000"); 
            visiblePath.setAttribute("stroke-width", config.strokeWidth);
            visiblePath.setAttribute("stroke-dasharray", config.dashArray);
            visiblePath.setAttribute("mask", `url(#mask-${config.sectionId})`);

            svgEl.appendChild(visiblePath);
            container.appendChild(svgEl);

            const totalLength = maskPath.getTotalLength();
            
            const circleGroup = document.createElementNS(svgNS, "g");
            circleGroup.setAttribute("mask", `url(#mask-${config.sectionId})`); 
            
            circlePositions.forEach((fraction, index) => {
                const pointDistance = fraction * totalLength;
                const pt = maskPath.getPointAtLength(pointDistance);
                
                const circle = document.createElementNS(svgNS, "circle");
                circle.setAttribute("cx", pt.x);
                circle.setAttribute("cy", pt.y);
                circle.setAttribute("r", "6"); 
                circle.setAttribute("fill", config.strokeColor || "#ffffff"); 
                
                circle.setAttribute("class", `random-svg-circle circle-${config.sectionId}-${index}`);
                circleGroup.appendChild(circle);
            });
            
            svgEl.appendChild(circleGroup);

            gsap.set(maskPath, {
                strokeDasharray: totalLength,
                strokeDashoffset: totalLength
            });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: config.scrubStart,
                    end: config.scrubEnd,
                    scrub: true,
                    invalidateOnRefresh: true
                }
            });

            tl.to(maskPath, {
                duration: 1,
                strokeDashoffset: 0,
                ease: "none" 
            }, 0);

            scrollTween = tl;
        }

        build();
        
        if (container.__resizeHandler) {
          window.removeEventListener('resize', container.__resizeHandler);
        }
        let resizeTimer;
        container.__resizeHandler = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(build, 200);
        };
        window.addEventListener('resize', container.__resizeHandler);
    }

    sectionConfigs.forEach(attachConnector);
  }
 // gsap.registerPlugin(ScrollTrigger);
  if (!window.gsap || !window.ScrollTrigger) return; 
  var ROUTE_MIN_W = 1200; // must match the CSS breakpoint

  // Sample a path into points every `step` units of length.
  function samplePoints(path, len, step) {
    var pts = [];
    for (var at = 0; at <= len; at += step) {
      pts.push(path.getPointAtLength(at));
    }
    var last = path.getPointAtLength(len);
    if (!pts.length || pts[pts.length - 1].x !== last.x || pts[pts.length - 1].y !== last.y) {
      pts.push(last);
    }
    return pts;
  }

  // Build a polyline "d" string from sampled points, optionally reversed.
  function pointsToD(pts, reversed) {
    var ordered = reversed ? pts.slice().reverse() : pts;
    return ordered.map(function (p, i) {
      return (i === 0 ? "M" : "L") + p.x + "," + p.y;
    }).join(" ");
  }

  // Order a set of route path elements so consecutive entries connect
  // end-to-start, chaining by nearest endpoint. Returns
  // [{ el, len, reversed }] in draw order. `reversed: true` means the
  // segment's authored start point is actually the end that should be
  // drawn last (it connects to the previous segment's tail).
  function orderRoutes($routesJQ) {
    var arr = $routesJQ.toArray();
    var infos = arr.map(function (p) {
      var len = p.getTotalLength() || 1;
      return {
        el: p,
        len: len,
        start: p.getPointAtLength(0),
        end: p.getPointAtLength(len)
      };
    });

    if (infos.length <= 1) {
      return infos.map(function (i) { return { el: i.el, len: i.len, reversed: false }; });
    }

    var remaining = infos.slice();
    var first = remaining.shift();
    var ordered = [{ el: first.el, len: first.len, reversed: false, _end: first.end }];

    while (remaining.length) {
      var tail = ordered[ordered.length - 1]._end;
      var bestIdx = -1, bestDist = Infinity, bestReversed = false, bestEnd = null;

      remaining.forEach(function (info, i) {
        var dStart = Math.hypot(info.start.x - tail.x, info.start.y - tail.y);
        var dEnd = Math.hypot(info.end.x - tail.x, info.end.y - tail.y);
        if (dStart < bestDist) { bestDist = dStart; bestIdx = i; bestReversed = false; bestEnd = info.end; }
        if (dEnd < bestDist) { bestDist = dEnd; bestIdx = i; bestReversed = true; bestEnd = info.start; }
      });

      var next = remaining.splice(bestIdx, 1)[0];
      ordered.push({ el: next.el, len: next.len, reversed: bestReversed, _end: bestEnd });
    }

    return ordered.map(function (o) { return { el: o.el, len: o.len, reversed: o.reversed }; });
  }

  function buildJourneyLines() {
    ScrollTrigger.getAll().forEach(function (st) {
      if (st.vars && st.vars.__hpDraw) st.kill();
    });

    $("svg[data-draw]").each(function () {
      var svg = this;
      var $svg = $(svg);

      // undo any inline draw-state left over from a previous build (e.g. on resize)
      $svg.find(".hp-draw__mark-lit").remove();
      $svg.find("mask[id^='hp-draw-mask-']").remove();

      var $section = $svg.closest("section");
      var $routes = $svg.find("path[stroke-dasharray]");
      var $marks = $svg.find("path").not("[stroke-dasharray]");

      if (!$routes.length) return;

      $routes.each(function () { this.removeAttribute("mask"); });

      if ($(window).width() < ROUTE_MIN_W) {
        // below the breakpoint the route is hidden by CSS — nothing else to reset
        return;
      }

      var ns = "http://www.w3.org/2000/svg";

      // Chain route segments in visual draw order instead of trusting DOM
      // order / authored path direction. This is what fixes both
      // "starts from the middle" and "segments don't connect".
      var ordered = orderRoutes($routes);

      // Build every segment's mask first (so all geometry/marks-matching
      // below has access to the full set), but give each one its OWN
      // ScrollTrigger keyed to that segment's own position in the page,
      // instead of one shared trigger across the whole section.
      var segments = []; // { visiblePath, maskPath, len }

      ordered.forEach(function (info) {
        var path = info.el; // the real, visible, dashed path
        var len = info.len;
        var step = Math.max(2, len / 200);
        var pts = samplePoints(path, len, step);

        var maskId = "hp-draw-mask-" + Math.random().toString(36).slice(2, 8);
        var mask = document.createElementNS(ns, "mask");
        mask.setAttribute("id", maskId);
        mask.setAttribute("maskUnits", "userSpaceOnUse");

        var maskPath = document.createElementNS(ns, "path");
        // Rebuild the mask geometry in actual draw order. If this segment's
        // authored start connects to the *previous* segment's end, walk it
        // in reverse so the reveal direction is continuous across segments.
        maskPath.setAttribute("d", pointsToD(pts, info.reversed));
        maskPath.setAttribute("fill", "none");
        maskPath.setAttribute("stroke", "#fff");
        var visibleWidth = parseFloat(path.getAttribute("stroke-width")) || 2;
        maskPath.setAttribute("stroke-width", visibleWidth + 4);

        mask.appendChild(maskPath);
        svg.appendChild(mask);
        path.setAttribute("mask", "url(#" + maskId + ")");

        maskPath.style.strokeDasharray = len;
        maskPath.style.strokeDashoffset = len;

        segments.push({ visiblePath: path, maskPath: maskPath, len: len });
      });

      // One ScrollTrigger PER SEGMENT, triggered by that segment's own
      // visible path element entering/leaving the viewport. This is what
      // makes each part of the line draw when its own bit of the SVG is
      // actually on screen, rather than on a fixed proportional schedule.
      segments.forEach(function (seg) {
        var segTl = gsap.timeline({
          scrollTrigger: {
            __hpDraw: true,
            trigger: seg.visiblePath,
            start: "top 75%",   // segment's top enters 85% down the viewport
            end: "bottom 45%",  // finishes once its bottom passes the midline
            scrub: 0.6,
            markers:false
          }
        });

        segTl.fromTo(seg.maskPath,
          { strokeDashoffset: seg.len },
          { strokeDashoffset: 0, ease: "none" });

        seg._tl = segTl; // stash so marks can add tweens to the right timeline
      });

      if ($marks.length) {
        // For each mark, find the nearest point across ALL segments, but
        // remember which segment it belongs to and its LOCAL position
        // along that segment (0-1) — marks now key off their own
        // segment's timeline, not one shared global timeline.
        $marks.each(function () {
          var m = this;
          var b;
          try { b = m.getBBox(); } catch (e) { return; }
          var cx = b.x + b.width / 2;
          var cy = b.y + b.height / 2;

          var best = Infinity, bestSeg = null, bestLocalT = 0;

          segments.forEach(function (seg) {
            var len = seg.len;
            var step = Math.max(2, len / 150);
            for (var at = 0; at <= len; at += step) {
              var pt = seg.maskPath.getPointAtLength(at);
              var dx = pt.x - cx, dy = pt.y - cy;
              var d = dx * dx + dy * dy;
              if (d < best) { best = d; bestSeg = seg; bestLocalT = at / len; }
            }
          });

          if (!bestSeg) return;

          var $m = $(m);
          var fill = $m.attr("fill");
          var stroke = $m.attr("stroke");
          var hasFill = fill && fill !== "none";
          var hasStroke = stroke && stroke !== "none";

          var lit = m.cloneNode(false);
          if (hasFill && !hasStroke) lit.style.fill = "var(--hp-draw-accent)";
          if (hasStroke) lit.style.stroke = "var(--hp-draw-accent)";
          $(lit).addClass("hp-draw__mark-lit");
          svg.appendChild(lit);
          gsap.set(lit, { autoAlpha: 0 });

          bestSeg._tl.to(lit, { autoAlpha: 1, duration: 0.02, ease: "none" }, Math.min(bestLocalT, 0.98));
        });
      }
    });
  }

  buildJourneyLines();

  var resizeT;
  $(window).on("resize", function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      buildJourneyLines();
      ScrollTrigger.refresh();
    }, 250);
  });

  $(window).on("load", function () {
    ScrollTrigger.refresh(true);
  });


  function modeToggler(){
    $('.icon-light-mode').on('click', function(){
      $('body').addClass('dark');
      $(this).css({'display':'none'})
      $('.icon-dark-mode').css({'display':'block'})
    });
    $('.icon-dark-mode').on('click', function(){
      $('body').removeClass('dark');
      $(this).css({'display':'none'})
      $('.icon-light-mode').css({'display':'block'})
    });
  }

  // ==========================================================================
  // 6. PAGE INIT
  // ==========================================================================
  function initPageFunctions() {

    headerSetup();
    hideMenuSrollbar(); 
    searchPage();
    modeToggler();
    addHoverCursorClass();

    setTabSlider();
    initSliders();
    parallaxBanner();
    animIntroText();
    animSectionTitle();
    createHorizontalScroll();
    pinHighlightsPanel();
    initCeoSticky();
    callCounters();
    homeLeaderboard();
    //animateSVGLines();
    revealImages(); 
 
    


    requestAnimationFrame(() => {
      ScrollTrigger.refresh();
      if (typeof lenis !== "undefined" && lenis) lenis.resize();
    });
  }

  // ==========================================================================
  // 7. TAB CHANGE FIX
  // ==========================================================================
  $(document).on(
  "shown.bs.tab",
  'button[data-bs-toggle="tab"], a[data-bs-toggle="tab"]',
  function () {
    isTabSwitching = true;
    clearTimeout(tabSwitchTimer);

    tabSwitchTimer = setTimeout(() => {
      createHorizontalScroll(true);
      pinHighlightsPanel(true);
      initWowAnimations();
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
        if (typeof lenis !== "undefined" && lenis) lenis.resize();

        requestAnimationFrame(() => {
          isTabSwitching = false;
        });
      });
    }, 150);
  }
);

  // ==========================================================================
  // 8. WINDOW EVENTS
  // ==========================================================================
  $(window).on("scroll", function () {
    setHeaderOnScroll();
    setHeaderAnim();
  });

  let resizeTimer = null;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      winWT = $(window).innerWidth();
      headerHT = header.innerHeight();

      resetMobileMenu();

      // Defer the rebuild + refresh by a couple of frames so the browser
      // finishes reconciling scroll position / document height after the
      // old pin-spacer is removed (this matters when the user is scrolled
      // mid-timeline or past it at resize time — otherwise the new
      // ScrollTrigger's start/end, and therefore its pin-spacer height,
      // get computed against a layout that hasn't settled yet).
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          createHorizontalScroll(true);
          pinHighlightsPanel(true);

          ScrollTrigger.refresh(true);
          if (typeof lenis !== "undefined" && lenis) lenis.resize();
        });
      });
    }, 150);
  });
  
  // ==========================================================================
  // 9. INITIAL RUN
  // ==========================================================================
  initPageFunctions();
  function searchPage() {
    var fuse = null;
    var pages = [];


    var els = {
      openBtn: document.getElementById('openSearchModal'),
      closeBtn: document.getElementById('closeSearchModal'),
      overlay: document.getElementById('searchPopupOverlay'),
      input: document.getElementById('popupSearchInput'),
      resultsList: document.getElementById('resultsList'),
      meta: document.getElementById('resultMeta'),
      chips: document.querySelectorAll('.search-chip')
    };

    // Safety check: If the modal HTML isn't on this page, don't run the script
    if (!els.openBtn || !els.overlay) return;

    function escapeRegExp(str) { return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function escapeHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function sanitizeQuery(raw) {
      return String(raw).replace(/<[^>]*>/g, '').replace(/javascript:/gi, '').replace(/on\w+\s*=/gi, '').trim();
    }

    function buildSnippet(text, query) {
      if (!text) return '';
      var lower = text.toLowerCase();
      var idx = lower.indexOf(query.toLowerCase());
      var start = idx > -1 ? Math.max(0, idx - 40) : 0;
      var slice = text.slice(start, start + 120);
      var safeSlice = escapeHtml(slice);
      var re = new RegExp('(' + escapeRegExp(escapeHtml(query)) + ')', 'ig');
      var highlighted = safeSlice.replace(re, '<mark>$1</mark>');
      return (start > 0 ? '…' : '') + highlighted + '…';
    }

    function render(results, query) {
      els.resultsList.innerHTML = '';

      if (!query) {
        els.meta.textContent = 'Start typing to search...';
        return;
      }

      if (results.length === 0) {
        els.meta.textContent = 'No results found for “' + query + '”';
        return;
      }

      els.meta.textContent = results.length + ' result' + (results.length === 1 ? '' : 's') + ' for “' + query + '”';

      results.slice(0, 10).forEach(function (r) {
        var p = r.item;
        var isPdf = /\.pdf($|\?)/i.test(p.url);

        var a = document.createElement('a');
        a.className = 'result-item';
        a.href = escapeHtml(p.url);
        if (isPdf) {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        }
        a.innerHTML =
          '<h4 class="result-title">' + escapeHtml(p.title) + '</h4>' +
          '<div class="result-url">' + escapeHtml(p.url) + '</div>' +
          '<p class="result-snippet">' + buildSnippet(p.content, query) + '</p>';
        els.resultsList.appendChild(a);
      });
    }

    function runSearch(query) {
      if (!fuse) return;

      var trimmed = query.trim();
      if (!trimmed) {
        render([], '');
        return;
      }

      var queryWords = trimmed.toLowerCase().split(/\s+/).filter(Boolean);
      var fuseResults = fuse.search(trimmed);

      // Require every word in the query to appear in the page content —
      // this drops partial matches like "financial" alone when the
      // search was for "financial statement"
      var results = fuseResults.filter(function (r) {
        var haystack = (r.item.content || '').toLowerCase();
        return queryWords.every(function (word) {
          return haystack.indexOf(word) !== -1;
        });
      });

      render(results, trimmed);
    }

    async function init() {
      // 1. Fetch JSON from the local file
      var indexUrl = '/project-2026/ar-25-26/bajaj-finance/search-index.json';
      try {
        var res = await fetch(indexUrl, { cache: 'no-cache' });
        if (!res.ok) throw new Error('Network response was not ok');
        var rawPages = await res.json();
        
        // 2. Filter out empty descriptions (FIXED: Now allows .html pages)
        pages = rawPages;

        // 3. Initialize Fuse
        fuse = new Fuse(pages, {
          /* keys: [{ name: 'title', weight: 0.5 }, { name: 'description', weight: 0.3 }, { name: 'content', weight: 1.0 }], */
          keys: [{ name: 'title', weight: 0.5 }, { name: 'content', weight: 1.0 }],
          threshold: 0.3, ignoreLocation: true, minMatchCharLength: 2 /* distance: 100,  */
        });

        els.meta.textContent = 'Start typing to search...';

      } catch (err) {
        console.error('[search] Init failed:', err);
        els.meta.textContent = 'Failed to load search data. Please try again later.';
      }
    }

    function openModal() {
      els.overlay.classList.remove('d-none');

      if (window.lenis && typeof window.lenis.stop === 'function') {
        //window.lenis.stop();
      } else {
        document.body.style.overflow = 'hidden';
      }

      setTimeout(function() { els.input.focus(); }, 100);
    }

    function closeModal() {
      els.overlay.classList.add('d-none');

      if (window.lenis && typeof window.lenis.start === 'function') {
        //window.lenis.start();
      } else {
        document.body.style.overflow = '';
      }
    }

    els.openBtn.addEventListener('click', function(e) {
      console.log('sdfdsf');
      e.preventDefault(); 
      openModal();
    });

    els.closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closeModal();
    });
    
    els.overlay.addEventListener('click', function(e) {
      if (e.target === els.overlay) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !els.overlay.classList.contains('d-none')) {
        closeModal();
      }
    });

    els.input.addEventListener('input', function() {
      runSearch(sanitizeQuery(this.value));
    });

    // Update the chips loop to also prevent default actions
    for (var i = 0; i < els.chips.length; i++) {
      els.chips[i].addEventListener('click', function(e) {
        e.preventDefault();
        els.input.value = this.textContent;
        els.input.focus();
        runSearch(this.textContent);
      });
    }



    // Run initialization immediately
    init();
  }

// THIS IS THE CRITICAL FIX: 
// Tells the browser to run your function as soon as the HTML is loaded.
if (document.readyState === 'loading') {
    // If it's still loading, wait for it
    document.addEventListener('DOMContentLoaded', searchPage);
} else {
    // If it's already loaded, run it immediately
    searchPage();
}
    
});
